import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";
import GoogleSignInButton from "@/components/GoogleSignInButton";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [email, setEmail] = useState(state?.email || "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back"); navigate(state?.from || "/app/dashboard"); }
    else toast.error(res.error);
  };

  return (
    <AuthLayout title="Sign in" subtitle="Continue where your mobile app left off."
      footer={<span>New here? <Link to="/register" className="font-semibold text-brand hover:underline">Create an account</Link></span>}>
      <div className="space-y-4" data-testid="login-form">
        <GoogleSignInButton />
        <div className="flex items-center gap-3 text-xs text-muted">
          <span className="h-px flex-1 bg-line" /> or with email <span className="h-px flex-1 bg-line" />
        </div>
      </div>
      <form onSubmit={submit} className="mt-4 space-y-4">
        <div>
          <label className="mb-1.5 block text-sm font-medium text-ink">Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email"
            className="w-full rounded-md border border-line bg-white px-3.5 py-2.5 text-sm outline-none transition-colors focus:border-brand" />
        </div>
        <div>
          <div className="mb-1.5 flex items-center justify-between">
            <label className="block text-sm font-medium text-ink">Password</label>
            <Link to="/forgot-password" className="text-xs text-brand hover:underline">Forgot?</Link>
          </div>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password"
            className="w-full rounded-md border border-line bg-white px-3.5 py-2.5 text-sm outline-none transition-colors focus:border-brand" />
        </div>
        <button type="submit" disabled={loading} data-testid="login-submit"
          className="flex w-full items-center justify-center gap-2 rounded-md bg-brand py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-dark disabled:opacity-60">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
        <p className="rounded-md bg-brand-wash px-3 py-2 text-xs text-brand-dark">
          Use the same email &amp; password as your Better Days mobile app — it's one shared account.
        </p>
      </form>
    </AuthLayout>
  );
}
